import { combineReducers } from 'redux'
import { createForms } from 'react-redux-form/immutable'
import { routerReducer as routing } from 'react-router-redux'

import app from 'containers/App/reducer'
import { passwordState } from 'containers/Account/reducer'
import notification from 'components/Notification/reducer'
import auth, { loginState } from 'containers/Auth/reducer'
import { changeSemState } from 'containers/Admin/reducer'
import admission, { admissionState } from 'containers/Admission/reducer'
import student, { studentState } from 'containers/Students/reducer'
import sccourse from 'containers/Courses/reducer'
import curriculum from 'containers/Curriculums/reducer'
import paymentscheme from 'containers/PaymentSchemes/reducer'
import scscholarship from 'containers/Scholarships/reducer'
import advising, { advisingState } from 'containers/Advising/reducer'
import billing, { billingHeaderState, feeFormState } from 'containers/Billing/reducer'
import fee from 'containers/Fees/reducer'
import ledger from 'containers/Ledger/reducer'

export default combineReducers({
  // main reducers
  app,
  auth,
  notification,
  admission,
  student,
  sccourse,
  curriculum,
  paymentscheme,
  scscholarship,
  advising,
  billing,
  fee,
  ledger,

  // react-redux-form
  ...createForms({
    loginState,
    passwordState,
    changeSemState,
    studentState,
    admissionState,
    advisingState,
    billingHeaderState,
    feeFormState,
  }),

  // other
  routing,
})



// WEBPACK FOOTER //
// ./src/reducers.js